export default () => ({
  el: undefined,
  form: undefined,
  deleteButton: undefined,
  docs: undefined,
  modalId: undefined,
  init() {
    mrp.log(`RxFileList init`);
    this.el = this.$el;
    this.form = this.$refs.form;
    this.deleteButton = this.$refs.deleteButton;
    this.docs = this.$refs.docs;
    this.modalId = this.deleteButton.getAttribute("data-modal-id");
  },
  delete() {
    mrp.log(`RxFileList delete`);
    // trigger the htmx form submit for selected document deletion
    htmx.trigger(this.form, "submit", {});
  },
  change() {
    mrp.log(`RxFileList change`);
    // manage the enabled/disabled state of the delete button based on any selected files
    let docs = this.docs.querySelectorAll("[id^='doc-']");
    this.deleteButton.setAttribute("disabled", "");
    for (let i = 0; i < docs.length; i++) {
      if (docs[i].checked) {
        this.deleteButton.removeAttribute("disabled");
        return;
      }
    }
  },
  trigger() {
    let modal = document.getElementById(this.modalId);
    modal.showModal();
  },
});
